import { MobXProviderContext } from "mobx-react";
import React from "react";
import { RootStoreProps } from "Stores/RootStore.types";

export const useCurrentUserContext = () => {
  const { person: personStore, conversation: conversationStore } =
    React.useContext<RootStoreProps>(MobXProviderContext);

  return {
    currentUserId: personStore.loggedInPersonId?.toString() || '',
    currentConversationId: conversationStore.CurrentConversation?.id?.toString() || '',
  };
};
